import { render } from "./PhysicalMeetingConfirm.vue?vue&type=template&id=065de92e"
import script from "./PhysicalMeetingConfirm.vue?vue&type=script&lang=js"
export * from "./PhysicalMeetingConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1815703633/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__